<template>
    <div class="user-detail">
        <div class="box">
            <div class="title">基础信息</div>
            <el-row>
                <el-col :span="8">
                    <span class="label">设备类型：</span>
                    <span class="value">{{ detail.deviceType }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">设备类别：</span>
                    <span class="value">{{ detail.deviceName }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">设备SN码：</span>
                    <span class="value">{{ detail.deviceSn }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">激活时间：</span>
                    <span class="value">{{ detail.activationTime }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">激活用户ID：</span>
                    <span class="value">{{ detail.userId }}</span>
                </el-col>
                <el-col :span="8">
                    <span class="label">用户手机：</span>
                    <span class="value">{{ detail.userMobile }}</span>
                </el-col>
            </el-row>
        </div>
        <div class="box">
            <div class="title">设备数据读取记录</div>
            <el-table>
                <el-table-column label="序号"></el-table-column>
                <el-table-column label="时间"></el-table-column>
                <el-table-column label="时长"></el-table-column>
                <el-table-column label="数据包大小"></el-table-column>
                <el-table-column label="操作"></el-table-column>
            </el-table>
        </div>
        <div class="box">
            <div class="title">设备轨迹记录</div>
            <el-table>
                <el-table-column label="序号"></el-table-column>
                <el-table-column label="时间"></el-table-column>
                <el-table-column label="时长"></el-table-column>
                <el-table-column label="时速"></el-table-column>
                <el-table-column label="里程"></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
import { detail } from "@/api/device/list";
export default {
    data() {
        return {
            detail: {}
        }
    },
    mounted() {
        this.getDetail();
    },
    methods: {
        getDetail() {
            detail({ id: this.id }).then(({ code, result, message }) => {
                if (code == 200) {
                    this.detail = result || {};
                }
            });
        }
    }
}
</script>

<style lang="less" scoped>
.user-detail {
    display: flex;
    flex-direction: column;
    row-gap: 20px;

    background: #f5f5f5;

    .box {
        padding: 10px 20px 20px;
        background: #fff;
        border-radius: 8px;
    }

    .card {
        background: #f9fbfc;
        margin: 10px;
        padding: 10px;
        border-radius: 8px;

        .name {
            color: #999;
            font-size: 14px;
        }

        .data {
            color: #333;
            font-size: 20px;
        }
    }
}
</style>